import { useDispatch, useSelector } from "react-redux";
import TableAHSF from "../../../Components/TableAHSF";
import {
  GetApplicationByRound,
  GetApplicationInformation,
} from "../../../Redux/Reducers/Shared/ApplicationInformation";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TermsAndAddApplication from "../TermsAndAddApplication";

const MainPage = () => {
  const dispatch = useDispatch();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const navigate = useNavigate();
  const [PopupComponentStatus, SetPopupComponentStatus] = useState(false);
  const lang = useSelector((state) => state.languageReducer.Language);

  const state = useSelector((state) => {
    return {
      ApplicationByRound: state.ApplicationInformation.ApplicationByRound,
    };
  });
  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      NmaeColumnEN: "Application Number",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: lang == "ar" ? "statusNameAr" : "statusNameEn",
      ShowStatus: true,
      NmaeColumn: "حالة الطلب",
      NmaeColumnEN: "Status",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "roundNameAr",
      ShowStatus: true,
      NmaeColumn: "سنة التقدم",
      NmaeColumnEN: "Round Year",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        localStorage.setItem(
          "ApplicationInformationId",
          JSON.parse(e.target.value).applicationInformationId
        );
        navigate("/ResearchersAward/ApplicationInformation");

        console.log(JSON.parse(e.target.value), "HHH");
      },

      content:
        lang != "en" ? "استكمال تعبئة الطلب" : "Complete the application",
      //  content: [
      //   <span className="edit-animated">
      //     <i className="bi bi-pencil-fill"></i>
      //   </span>,
      //    <>
      //     استكمال تعبئة الطلب
      //    </>
      // ],
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "استكمال تعبئة الطلب",
      ShowStatus: true,
      ShowHideBtn: [
        {
          KeyName: "applicationStatusId",
          Value: "f4c6c3e1-c49e-4361-8c86-c3015da12750",
          statusToWork: true,
        },
      ],
    },
    {
      Click: async (e) => {
        localStorage.setItem(
          "ApplicationInformationId",
          JSON.parse(e.target.value).applicationInformationId
        );
        navigate("/ResearchersAward/ApplicationInformation");
      },
      content: lang != "en" ? "عرض الطلب" : "View ",
      className: "bi bi-eye-fill",
      id: "editBtn",
      title: "عرض الطلب",
      ShowStatus: true,
      ShowHideBtn: [
        {
          KeyName: "applicationStatusId",
          Value: "f4c6c3e1-c49e-4361-8c86-c3015da12750",
          statusToWork: true,
          Condition:"Not"
        },
      ],
    },
  ];

  const RequestsColumns = [];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        <TermsAndAddApplication />
      </div>
    ),
    maxWidth: "700px",
    maxHeight: "600px",
  };

  const closePopupComponent = () => {
    SetPopupComponentStatus(false);
  };

  useEffect(() => {
    dispatch(GetApplicationByRound());
  }, []);
  console.log(state.ApplicationByRound, "ApplicationByRound");

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        lang={localStorage.getItem("lang")}
        uniqueValue={""}
        valueButtonAction={""}
        URL={`api/AI_NT_AI_ApplicationInformation/GetAllApplicationByUserGuid`}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={state.ApplicationByRound == true ? "تقديم طلب" : ""}
        titelTableEN={state.ApplicationByRound == true ? "Apply" : ""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={state.ApplicationByRound==true}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={false}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        arrayButton={OtherMainBtns}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        // popUpBody2={[<ShowApplication addFun={true} />]}
        // popUpId2={"ShowApplicationpopUp"}
        // popUpBody2={[
        //   <ShowApplication columnId={columnId} list={list} addFun={false} />,
        // ]}
        // handleCloseModal={handleCloseModal}
        // showModal={showPopUp}
      />
    </>
  );
};

export default MainPage;
